import { render, staticRenderFns } from "./FormIndex.vue?vue&type=template&id=96354a6e&"
import script from "./FormIndex.vue?vue&type=script&lang=js&"
export * from "./FormIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarTitle } from 'vuetify/lib/components/VAppBar';
installComponents(component, {VAppBar,VAppBarTitle})
